import React from "react";
import {
  SFIconButton,
  SFRadioButtonCheckedIcon,
  SFRadioButtonUncheckedIcon,
} from "@sf-core";

export const RadioButtonRenderer = ({ node, selectedVideoName, onSelect }) => {
  const isSelected = node.data.name === selectedVideoName;

  return (
    <SFIconButton onClick={() => onSelect && onSelect(node.data)}>
      {isSelected ? (
        <SFRadioButtonCheckedIcon color="blue400" />
      ) : (
        <SFRadioButtonUncheckedIcon color="grey450" />
      )}
    </SFIconButton>
  );
};
